// extracted by mini-css-extract-plugin
module.exports = {"shoplist":"shoplist_shoplist__3BDgd","shoplist_tr":"shoplist_shoplist_tr__V8IYJ","emptyCart":"shoplist_emptyCart__e1-uq"};